
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type AddConversationMessage400Details = { [key: string]: unknown } | null;
